window.announcekit = (window.announcekit || {
  queue: [],
  on(eventName, handler) {
    window.announcekit.queue.push([eventName, handler]);
  },
  push(payload) {
    window.announcekit.queue.push(payload);
  }
});

window.announcekit.push({
  widget: 'https://changelog.soracom.io/widgets/v2/KDada',
  selector: '.announcekit-widget',
  lang: 'en'
});

(() => {
  const processedBadges = new WeakSet();
  const processedIframes = new WeakSet();

  function adjustBadgeLabel(root = document) {
    root.querySelectorAll('a.announcekit-widget-badge').forEach((badge) => {
      if (processedBadges.has(badge)) {
        return;
      }

      // Convert badge from clickable <a> to non-clickable <span> for accessibility
      // The badge should be visual only - only the main bell icon should be clickable
      const span = document.createElement('span');
      span.className = badge.className;
      span.setAttribute('aria-hidden', 'true'); // Hide from screen readers since it's decorative

      // Copy all attributes except href, target, height, and aria-label (which make it clickable or problematic)
      Array.from(badge.attributes).forEach(attr => {
        if (attr.name !== 'href' && attr.name !== 'target' && attr.name !== 'aria-label' && attr.name !== 'height') {
          span.setAttribute(attr.name, attr.value);
        }
      });

      // Remove height from inline styles if present
      if (badge.style.height) {
        span.style.height = '';
      }
      // Remove cursor: pointer to make it clear it's not clickable
      if (badge.style.cursor === 'pointer') {
        span.style.cursor = 'default';
      }

      // Copy all child nodes (including SVG)
      while (badge.firstChild) {
        span.appendChild(badge.firstChild);
      }

      // Replace the <a> with <span>
      badge.parentNode.replaceChild(span, badge);

      // Process the new span element
      const textElement = span.querySelector('svg g text');
      if (textElement) {
        textElement.setAttribute('y', '78');
      }

      processedBadges.add(span);
    });
  }

  function titleIframe(iframe) {
    if (processedIframes.has(iframe)) {
      return;
    }

    const src = (iframe.getAttribute('src') || '').toLowerCase();
    if (!iframe.getAttribute('title')) {
      if (src.includes('statuspal.io')) {
        iframe.setAttribute('title', 'Status page widget');
      } else if (src.includes('changelog.soracom.io') || src.includes('announcekit')) {
        iframe.setAttribute('title', 'Product updates widget');
      } else if (src.includes('youtube.com') || src.includes('youtu.be')) {
        iframe.setAttribute('title', 'YouTube video');
      } else {
        iframe.setAttribute('title', 'Embedded content');
      }
    }

    processedIframes.add(iframe);
  }

  function ensureIframeTitles(root = document) {
    root.querySelectorAll('iframe').forEach(titleIframe);
  }

  function processNode(node) {
    if (!(node instanceof Element)) {
      return;
    }

    if (node.matches('iframe')) {
      titleIframe(node);
    } else {
      node.querySelectorAll('iframe').forEach(titleIframe);
    }

    // Check for both <a> (before conversion) and <span> (after conversion) badges
    if (node.matches('a.announcekit-widget-badge') || node.matches('span.announcekit-widget-badge')) {
      adjustBadgeLabel(node.parentElement || node);
    } else {
      const badge = node.querySelector('a.announcekit-widget-badge, span.announcekit-widget-badge');
      if (badge) {
        adjustBadgeLabel(badge.parentElement || badge);
      }
    }
  }

  let observer = null;

  function observeDom() {
    if (!document.body) {
      return;
    }

    observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(processNode);
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function cleanup() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function init() {
    adjustBadgeLabel();
    ensureIframeTitles();
    observeDom();

    window.addEventListener('load', () => adjustBadgeLabel());
  }

  // Cleanup on page unload to prevent memory leaks
  window.addEventListener('beforeunload', cleanup);
  window.addEventListener('pagehide', cleanup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
